export const RETURNS_CONSOLIDATED_SETTINGS_PATH = "returns" as const;

export const RETURNS_AUTOMATIONS_SETTINGS_PATH = "automations" as const;

export const RETURNS_AUTOMATIONS_PROCESSING_SEGMENT = "processing" as const;

export const RETURNS_AUTOMATIONS_PROCESSING_SETTINGS_PATH =
  `${RETURNS_AUTOMATIONS_SETTINGS_PATH}/${RETURNS_AUTOMATIONS_PROCESSING_SEGMENT}` as const;

export const RETURNS_COMPENSATION_FLOW_EDITOR_SEGMENT =
  "compensation-flow-editor" as const;

export const RETURNS_RESTOCKING_FLOW_EDITOR_SEGMENT =
  "restocking-flow-editor" as const;

export const RETURNS_COMPENSATION_FLOW_EDITOR_SETTINGS_PATH =
  `${RETURNS_AUTOMATIONS_PROCESSING_SETTINGS_PATH}/${RETURNS_COMPENSATION_FLOW_EDITOR_SEGMENT}` as const;

export const RETURNS_RESTOCKING_FLOW_EDITOR_SETTINGS_PATH =
  `${RETURNS_AUTOMATIONS_PROCESSING_SETTINGS_PATH}/${RETURNS_RESTOCKING_FLOW_EDITOR_SEGMENT}` as const;

export const RETURNS_LABELS_FLOW_EDITOR_SETTINGS_PATH =
  "shipping/labels-flow-editor" as const;

export const RETURNS_LOCATION_FLOW_EDITOR_SETTINGS_PATH =
  "shipping/location-flow-editor" as const;

export const RETURNS_WAREHOUSE_SETTINGS_PATH = "warehouse" as const;

export const RETURNS_WAREHOUSE_PROCESSING_FLOW_SETTINGS_PATH =
  `${RETURNS_WAREHOUSE_SETTINGS_PATH}/processing-flow` as const;

export const RETURNS_WAREHOUSE_PRODUCT_TRANSFORM_SETTINGS_PATH =
  `${RETURNS_WAREHOUSE_SETTINGS_PATH}/product-transform` as const;

export const RETURNS_WAREHOUSE_PHOTO_GUIDANCE_SETTINGS_PATH =
  `${RETURNS_WAREHOUSE_SETTINGS_PATH}/photo-guidance` as const;

export const RETURNS_AUTOMATION_CODE_FUNCTIONS_GROUP_ID =
  "returns.automation_code_functions" as const;

export const EXCHANGE_ORDER_CREATION_ARTIFACT_SETTING_ID =
  "returns/exchanges/orders/exchangeOrderCreationArtifactId" as const;

export const RETURN_ADJUSTMENT_ARTIFACT_SETTING_ID =
  "returns/automation/returnAdjustmentArtifactId" as const;

export const ORDER_SYNC_ARTIFACT_SETTING_ID =
  "returns/automation/orderSyncArtifactId" as const;
